// extracted by mini-css-extract-plugin
export default {"cls1":"yh5hzH7lF_z6K07l5aaQ","cls2":"yPululBtD1nDz64ZbsvQ yh5hzH7lF_z6K07l5aaQ","isPhone":"GmrQq3Yk4bz1FIJOOhh4"};